exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sidebar {\r\n  min-height: 93%;\r\n  background-color: #f8fff8;\n}\ndiv.copyright {\r\n  font-size: 10px;\n}\ndiv.copyright-info{\r\n  border-top: 1px solid #c5c5c5;\r\n  color: #666666;\r\n  text-align: center;\r\n  padding: 10px;\n}\ndiv.copyright img{\r\n  width: 200px;\r\n  margin-top: 10px;\r\n  margin-left: 60px;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d622f5c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Sidebar.vue
// module id = I4RN
// module chunks = 1